/**
 * @description Video Type / Format
 */
export enum VideoType {
	H264 = 'H264',
	HLS = 'HLS',
	MPEG4 = 'MPEG4',
	OGG = 'OGG',
	VP9 = 'VP9',
	WEBM = 'WEBM',
}